if (!customElements.get('rd-product-card')) {
  customElements.define(
    'rd-product-card',
    class RoomdenProductCard extends HTMLElement {
      connectedCallback() {
        this.swatches = Array.from(this.querySelectorAll('.rd-product-card__swatch'));
        this.image = this.querySelector('[data-card-image]');
        this.links = Array.from(this.querySelectorAll('[data-card-product-link]'));
        this.quickButton = this.querySelector('[data-card-quick-url]');
        this.swatchRow = this.querySelector('[data-card-swatch-row]');
        this.swatchTrack = this.querySelector('[data-card-swatch-track]');
        this.swatchPrevious = this.querySelector('[data-card-swatch-previous]');
        this.swatchNext = this.querySelector('[data-card-swatch-next]');

        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => this.selectSwatch(swatch));
        });

        if (this.swatchTrack) {
          this.swatchTrack.addEventListener('scroll', () => this.updateSwatchNavigation(), { passive: true });
          this.swatchPrevious?.addEventListener('click', () => this.scrollSwatches(-1));
          this.swatchNext?.addEventListener('click', () => this.scrollSwatches(1));
          this.swatchResizeObserver = new ResizeObserver(() => this.updateSwatchNavigation());
          this.swatchResizeObserver.observe(this.swatchRow);
          requestAnimationFrame(() => this.updateSwatchNavigation());
        }
      }

      disconnectedCallback() {
        this.swatchResizeObserver?.disconnect();
      }

      scrollSwatches(direction) {
        const amount = Math.max(this.swatchTrack.clientWidth * 0.72, 88);
        this.swatchTrack.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      updateSwatchNavigation() {
        if (!this.swatchTrack || !this.swatchRow) return;

        const swatches = Array.from(this.swatchTrack.children);
        const trackStyle = getComputedStyle(this.swatchTrack);
        const gap = Number.parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
        const contentWidth = swatches.reduce((total, swatch) => total + swatch.getBoundingClientRect().width, 0)
          + Math.max(swatches.length - 1, 0) * gap;
        const overflowing = contentWidth > this.swatchRow.clientWidth + 1;
        this.swatchRow.classList.toggle('is-overflowing', overflowing);

        if (!overflowing) {
          this.swatchPrevious?.setAttribute('aria-disabled', 'true');
          this.swatchNext?.setAttribute('aria-disabled', 'true');
          return;
        }

        const atStart = this.swatchTrack.scrollLeft <= 1;
        const atEnd = this.swatchTrack.scrollLeft + this.swatchTrack.clientWidth >= this.swatchTrack.scrollWidth - 1;
        this.swatchPrevious?.setAttribute('aria-disabled', String(atStart));
        this.swatchNext?.setAttribute('aria-disabled', String(atEnd));
      }

      selectSwatch(swatch) {
        this.swatches.forEach((candidate) => {
          candidate.setAttribute('aria-pressed', String(candidate === swatch));
        });

        if (this.image && swatch.dataset.image) {
          this.image.src = swatch.dataset.image;
          this.image.removeAttribute('srcset');
        }

        if (swatch.dataset.url) {
          this.links.forEach((link) => link.setAttribute('href', swatch.dataset.url));
          this.quickButton?.setAttribute('data-product-url', swatch.dataset.url);
        }

        swatch.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
  );
}
